import { Component } from "vuety";
import { IProductGroupItem } from "../../interfaces";
import { getRoot, findChild } from "../../root";
import Vue from "vue";
import { BaseView } from "../base";

const templateElement = "v-tmpl-groupsearch";

@Component({
	template: document.getElementById(templateElement)
		? "#" + templateElement
		: require("./search.html"),
	mixins: [BaseView]
})
export class SearchView extends Vue {
	public get groups(): IProductGroupItem[] {
		if (this.options.rootGroup) {
			const child = findChild(
				this.options.rootGroup,
				getRoot().currentData.Groups
			);
			if (!child) {
				console.warn(
					"No group data found for root group:",
					"'" + this.options.rootGroup + "'.",
					"This may be because the group is obsolete."
				);
				return [];
			}
			return this.getGroupStructure(child.Children, 0);
		} else {
			return this.getGroupStructure(getRoot().currentData.Groups, 0);
		}
	}

	public get searchTerm(): string {
		return getRoot().searchTerm;
	}

	getGroupStructure(
		groups: IProductGroupItem[],
		depth: number
	): IProductGroupItem[] {
		let indentedGroups: IProductGroupItem[] = [];
		if (depth < this.options.searchCatDepth) {
			let indentedGroups: IProductGroupItem[] = [];
			for (let i = 0; i < groups.length; i++) {
				let thisGroup: IProductGroupItem = Object.assign({}, groups[i]);
				thisGroup.GroupName = this.pad(depth) + thisGroup.GroupName;
				indentedGroups.push(thisGroup);
				if (groups[i].Children) {
					indentedGroups.push.apply(
						indentedGroups,
						this.getGroupStructure(groups[i].Children, depth + 1)
					);
				}
			}
			return indentedGroups;
		} else {
			return indentedGroups;
		}
	}

	pad(count: number) {
		let output: string = "";
		for (let i = 0; i < count; i++) {
			output += "&nbsp;&nbsp;&nbsp;&nbsp;";
		}
		return output;
	}
}



// WEBPACK FOOTER //
// ./src/views/search/search.ts